<div class="my-overlay" *ngIf="showOverlay">
    <div class="spinner-border m-5" role="status" style="color: white;" *ngIf="showOverlay">
      <span class="visually-hidden"></span>
    </div>
</div>
<app-list (pesquisar)="pesquisar($event);" (deletar)="deletar($event);" (baixarRota)="baixarRotaDoDia($event);" (adicionarCards)="adicionarCards($event)" [filtro]="filtro" [motoristas]="motoristas" [data]="rotas" [tipoEntradaDeDado]="tela"></app-list>